@if (hasContent && !isLoading) {
  <vw-extendable-card [headerTemplate]="cardHeaderTemplate" [bodyTemplate]="cardBodyTemplate">
    <ng-template #cardHeaderTemplate>
      <div class="flex items-center w-full h-12 min-w-0">
        <div [style.background-color]="backgroundColor | HexToHsl" class="h-full flex items-center px-3 gap-2 shrink-0">
          @if (currentWeather) {
            <div class="w-7 h-full flex items-center justify-center shrink-0">
              <vw-icon-svg [iconUrl]="iconUrl"></vw-icon-svg>
            </div>
            <p class="text-sm font-medium text-grey-900 pr-1">
              {{ currentWeather.currentTemperature }}°c
            </p>
          } @else {
            <span class="text-lg">🌱</span>
          }
        </div>
        <div class="flex-1 h-full flex items-center justify-between mr-8 min-w-0">
          <p class="text-xs pl-3 text-gray-700 truncate">{{ 'home.garden-today.title' | translate }}</p>
          @if (weatherTriggers.length > 0) {
            <span class="shrink-0 ml-2 inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold"
              [style.background-color]="chipStyle(weatherTriggers[0].trigger).background"
              [style.color]="chipStyle(weatherTriggers[0].trigger).ink">
              {{ chipStyle(weatherTriggers[0].trigger).emoji }}
              {{ 'home.garden-today.triggers.' + weatherTriggers[0].trigger | translate: weatherTriggers[0] }}
            </span>
          }
        </div>
      </div>
    </ng-template>

    <ng-template #cardBodyTemplate>
      <div class="w-full flex flex-col" [style.background-color]="backgroundColor | HexToHsl">
        @if (currentWeather) {
          <div class="w-full flex h-max p-4 justify-between items-end">
            <div class="w-2/3 h-full flex flex-col gap-2">
              <div class="flex flex-col gap-0.5">
                <h5 class="text-[16px] font-medium text-gray-800">
                  {{ currentDate | date: 'EEEE dd MMMM' | titlecase }}
                </h5>
                <p class="text-xs text-gray-700">{{ currentWeather.location }}</p>
              </div>
              <h3 class="text-[32px] font-semibold text-[#451a03]">
                {{ currentWeather.currentTemperature }}°c
              </h3>
              <ul class="flex items-center gap-2">
                <li class="flex items-center gap-[2px]">
                  <vw-icon-svg iconUrl="/assets/svg/weather/weather-arrow-up.svg" width="16" height="16"></vw-icon-svg>
                  <span class="text-xs text-[#451a03]">{{ currentWeather.maxTemperature }}°c</span>
                </li>
                <li class="flex items-center gap-[2px]">
                  <vw-icon-svg iconUrl="/assets/svg/weather/weather-arrow-down.svg" width="16" height="16"></vw-icon-svg>
                  <span class="text-xs text-[#451a03]">{{ currentWeather.minTemperature }}°c</span>
                </li>
                <li class="flex items-center gap-[2px]">
                  <vw-icon-svg iconUrl="/assets/svg/weather/weather-droplet.svg" width="16" height="16"></vw-icon-svg>
                  <span class="text-xs text-[#451a03]">{{ currentWeather.totalPrecipitation }}mm</span>
                </li>
              </ul>

              <!-- Weather trigger + moon chips -->
              <div class="flex items-center gap-1.5 mt-1 flex-wrap">
                @for (trigger of weatherTriggers; track trigger.trigger) {
                  <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold"
                    [style.background-color]="chipStyle(trigger.trigger).background"
                    [style.color]="chipStyle(trigger.trigger).ink">
                    <span>{{ chipStyle(trigger.trigger).emoji }}</span>
                    {{ 'home.garden-today.triggers.' + trigger.trigger | translate: trigger }}
                  </span>
                }
                @if (moonData) {
                  <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#261E77] text-white text-[10px] font-medium">
                    <span>🌙</span>
                    {{ 'home.weather.moon.phases.' + moonData.moonPhase | translate }}
                  </span>
                }
                @if (lunar) {
                  <!-- Cliquable : la chip nomme le jour sans dire quoi en faire.
                       Le détail, lui, donne les gestes. -->
                  <button type="button" (click)="openLunar($event)"
                    class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#261E77]/80 text-white text-[10px] font-medium">
                    <span>{{ moonPathIcon }}</span>
                    {{ 'home.lunar.moonPath.' + lunar.moonPath | translate }} ·
                    {{ 'home.lunar.influence.' + lunar.influence | translate }}
                    <span class="opacity-70">›</span>
                  </button>
                }
              </div>

              <!-- Deux entrées explicites : la carte répond « aujourd'hui »,
                   ces pages répondent « et les jours suivants ». -->
              <div class="flex items-center gap-2 mt-2">
                <button type="button" (click)="openWeather($event)"
                  class="inline-flex items-center gap-1 rounded-full bg-white/70 px-2.5 py-1 text-[11px] font-medium text-[#451a03]">
                  🌦️ {{ 'home.garden-today.see-weather' | translate }}
                </button>
                @if (lunar) {
                  <button type="button" (click)="openLunar($event)"
                    class="inline-flex items-center gap-1 rounded-full bg-white/70 px-2.5 py-1 text-[11px] font-medium text-[#451a03]">
                    🌙 {{ 'home.garden-today.see-lunar' | translate }}
                  </button>
                }
              </div>
            </div>
            <div class="w-1/3 h-full flex items-end justify-end">
              <vw-icon-svg [iconUrl]="weatherImg" class="h-full" additionalClasses="h-full" width="auto" height="100%"></vw-icon-svg>
            </div>
          </div>
        }
      </div>
    </ng-template>
  </vw-extendable-card>
}
@if (isLoading) {
  <vw-skeleton-loader [width]="'100%'" [height]="'48px'" [borderRadius]="'0.75rem'"></vw-skeleton-loader>
}
